export class CabdError extends Error {
    constructor(message) {
        super(message);
        this.name = 'CabdError';
    }
}
//# sourceMappingURL=types.js.map